import { createSlice } from '@reduxjs/toolkit';

const getNewDevicePromoCodeSlice = createSlice({
  name: 'getNewDevicePromoCode',
  initialState: {
    loading: false,
    newDevicePromoCode: null,
    error: null,
    success: false
  },
  reducers: {
    getNewDevicePromoCodeRequest(state) {
      state.loading = true;
      state.error = null;
      state.success = false;
    },
    getNewDevicePromoCodeSuccess(state, action) {
      state.loading = false;
      state.success = true;
      state.newDevicePromoCode = action.payload;
    },
    getNewDevicePromoCodeFailure(state, action) {
      state.loading = false;
      state.success = false;
      state.error = action.payload;
    }
  }
});

export const {
  getNewDevicePromoCodeRequest,
  getNewDevicePromoCodeSuccess,
  getNewDevicePromoCodeFailure
} = getNewDevicePromoCodeSlice.actions;

export default getNewDevicePromoCodeSlice.reducer;
